<template lang="pug">
  navbar
  #content( flex-item="grow-1" )
    router-view
  foot
</template>

<script>
import axios from 'axios'
import NavBar from './component/base/navigation.vue'
import Footer from './component/base/footer.vue'

export default {
  data () {
    return {
      user: null,
    }
  },
  computed: {},
  created () {
    axios.get('/api/users/me', {
      validateStatus: (status) => {
        return [200, 403].indexOf(status) != -1
      }
    }).then(response => {
      if (response.status == 200)
        this.user = response.data
    });
  },
  ready () {},
  attached () {},
  methods: {},
  components: {
    navbar: NavBar,
    foot: Footer
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// App.vue?cd127236